import { AppDownload } from './components/landing/AppDownload'
import { Cities } from './components/landing/Cities'
import { ComparisonTable } from './components/landing/ComparisonTable'
import { FAQ } from './components/landing/FAQ'
import { FeaturedTurfs } from './components/landing/FeaturedTurfs'
import { Features } from './components/landing/Features'
import { Hero } from './components/landing/Hero'
import { HowItWorks } from './components/landing/HowItWorks'
import { OwnerCTA } from './components/landing/OwnerCTA'
import { StatsBar } from './components/landing/StatsBar'
import { Testimonials } from './components/landing/Testimonials'
import { Ticker } from './components/landing/Ticker'
import { Footer } from './components/layout/Footer'
import { Navbar } from './components/layout/Navbar'
import { InstallBanner } from './components/pwa/InstallBanner'
import { PushNotifBanner } from './components/pwa/PushNotifBanner'

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <StatsBar />
        <HowItWorks />
        <FeaturedTurfs />
        <Cities />
        <Features />
        <ComparisonTable />
        <Testimonials />
        <AppDownload />
        <FAQ />
        <OwnerCTA />
      </main>
      <Footer />
      <InstallBanner />
      <PushNotifBanner />
    </>
  )
}
